import { Injectable } from '@angular/core';
import { TraitFilterRequest, TraitResultRequest } from './trait.reference.model';
import { ColumnModel } from '../shared/query/model/column.model';
import { TrialEnvironmentSearchRequest } from '../shared/query/model/trial-environment-search-request.model';
import { TrialEnvironmentSearchResponse } from '../shared/query/model/trial-environment-search-response.model';

@Injectable()
export class MultiTraitQueryContext {

    environmentSearch: TrialEnvironmentSearchRequest;
    private selectedAllEnvironments: boolean;
    private environmentColumns: ColumnModel[];
    private environmentSelectedItems: Map<number, TrialEnvironmentSearchResponse> = new Map<number, TrialEnvironmentSearchResponse>();
    private traitResultRequest: TraitResultRequest;


    setSelectedTraits(selectedTraits) {
        this.environmentSearch = new TrialEnvironmentSearchRequest(selectedTraits, [], []);
        this.environmentSearch.envConditions = [];
        this.environmentColumns = [];
        this.environmentSelectedItems = new Map<number, TrialEnvironmentSearchResponse>();
    }

    getSelectedTraits(): number[] {
        return this.environmentSearch.traits;
    }

    hasSelectTraits(): boolean {
        return this.environmentSearch && this.environmentSearch.traits.length > 0;
    }

    cleanSelectedTraits(): void {
        this.environmentSearch = new TrialEnvironmentSearchRequest([], [], []);
        this.environmentSearch.envConditions = [];
        this.environmentColumns = [];
        this.selectedAllEnvironments = false;
    }

    setSelectedAllEnvironments(selectedAll: boolean) {
        this.selectedAllEnvironments = selectedAll;
    }

    getSelectedAllEnvironments() {
        return this.selectedAllEnvironments;
    }

    cleanEnvColumns(): void {
        this.environmentSearch.envConditions = [];
    }

    addEnvConditions(column: ColumnModel): void {
        if (!this.environmentSearch.envConditions) {
            this.environmentSearch.envConditions = [];
            this.environmentColumns = [];
        }
        this.environmentSearch.envConditions.push(column.id);
    }

    setEnvironmentColumns(columns: ColumnModel[]) {
        this.environmentColumns = columns;
    }

    getEnvironmentColumns(): ColumnModel[] {
        return this.environmentColumns;
    }

    setEnvironmentSelectedItems(selectedItems: Map<number, TrialEnvironmentSearchResponse>): void {
        this.environmentSelectedItems = selectedItems;
    }

    getEnvironmentSelectedItems() {
        return this.environmentSelectedItems;
    }

    hasEnvironmentSelected(): boolean {
        return this.environmentSelectedItems != null && this.environmentSelectedItems.size > 0;
    }

    getTraitFilter() {
        const environments = Array.from(this.environmentSelectedItems.values()).map(environment => environment.id);
        return new TraitFilterRequest(environments, this.getSelectedTraits());
    }

    getTraitResultRequest() {
        return this.traitResultRequest;
    }

}